import React, { useState } from 'react';
import axios from 'axios';

import classNames from 'classnames';
import queryString from 'query-string';
import hyperid from 'hyperid';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;
const REFRESH_INTERVAL = 20000;
const MAIN_VOICE = 'Zira';
const FALLBACK_VOICE = 'David';
export const EventsCalendar = (props) => {
  const parsedQueryString = queryString.parse(window.location.search);
  const siteId = parseInt(parsedQueryString.siteId, 10);
  const [events, setEvents] = useState(null);
  const [site, setSite] = useState();
  const [session, setSession] = useState(null);
  const [time, setTime] = useState(new Date());
  const [currentStartEvents, setCurrentStartEvents] = useState(0);
  const [slicedEventsCountMax, setSlicedEventsCountMax] = useState(6);
  const [slicedEvents, setSlicedEvents] = useState(null);
  const siteLogoUrl = session && siteId ? `${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/getLogo/${siteId}?access_token=${session.id}` : '';

  const voices = speechSynthesis.getVoices();
  const ref = React.useRef({ voices: [], defaultVoice: null, soundQueue: [], speakerBusy: false });

  React.useEffect(() => {
    if (slicedEvents && slicedEvents.length) {
      manageSoundQueue(slicedEvents);
    }
  }, [slicedEvents]);

  React.useEffect(() => {
    if (ref.current.voices.length === 0 && voices.length) {
      ref.current.voices = voices;
      findDefaultVoice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voices]);

  React.useEffect(() => {
    props.hideLoader();
  }, [props]);

  React.useEffect(() => {
    setInterval(() => {
      setTime(new Date());
    }, 1000);
  }, []);

  React.useEffect(() => {
    let interval = setInterval(() => {
      if (!ref.current.speakerBusy) speakManager();
    }, [REFRESH_INTERVAL]);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const speakManager = async () => {
    ref.current.speakerBusy = true;
    const filtered = ref.current.soundQueue.filter((s) => !s.processed);
    for (const event of filtered) {
      if (!event.processed) {
        event.processed = true;
        await speak(event);
      }
    }
    ref.current.speakerBusy = false;
  };

  const manageSoundQueue = (slicedEvents = []) => {
    slicedEvents.forEach((event) => {
      if (event.startDate <= new Date().toISOString()) {
        const found = ref.current.soundQueue.find((q) => q.id === event.id);
        if (!found) ref.current.soundQueue.push({ ...event, processed: false });
      }
    });
  };

  function findDefaultVoice() {
    if (!ref.current.voices.length) return null;
    let voice = voices.find((v) => v.name.includes(MAIN_VOICE));
    if (!voice) voice = voices.find((v) => v.name.includes(FALLBACK_VOICE));
    if (!voice) voice = voices.find((v) => v.default);
    if (!voice) voice = voices.find((v) => v.lang.includes('en-US'));
    console.log('USING VOICE', voice.name + ' isDefault: ', voice.default);
    ref.current.defaultVoice = voice;
  }

  function speak(event) {
    return new Promise((res) => {
      console.log(`Now serving, ${event.name}. Please go to ${event.location}`);
      var msg = new SpeechSynthesisUtterance();
      msg.voice = ref.current.defaultVoice;
      msg.voiceURI = 'native';
      msg.volume = 1;
      msg.rate = 1;
      msg.pitch = 2;
      msg.text = `Now serving, ${event.name}. Please go to ${event.location}`;
      msg.lang = 'en-US';
      speechSynthesis.speak(msg);
      msg.onend = function () {
        setTimeout(() => {
          res(true);
        }, 1000);
      };
    });
  }

  React.useEffect(() => {
    if (siteId) {
      getSite();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteId, session]);

  React.useEffect(() => {
    let interval;
    getEvents();
    interval = setInterval(() => {
      getEvents();
    }, REFRESH_INTERVAL);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (events) {
      const sliced = events.slice(currentStartEvents, slicedEventsCountMax);
      setSlicedEvents(sliced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slicedEventsCountMax]);

  React.useEffect(() => {
    if (slicedEvents?.length) {
      setTimeout(() => {
        setCurrentStartEvents(slicedEventsCountMax);
        setSlicedEventsCountMax(slicedEventsCountMax + 6);
      }, 5000);
    } else {
      setSlicedEventsCountMax(6);
      setCurrentStartEvents(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slicedEvents]);

  React.useEffect(() => {
    if (events) {
      const sliced = events.slice(currentStartEvents, slicedEventsCountMax);
      setSlicedEvents(sliced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  const getEvents = async () => {
    let sess = session;
    if (!sess) sess = await initSession();

    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/events/${siteId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (data && data.events) {
      data.events.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
      setEvents(data.events);
    } else {
      console.log(`Error:`, data);
    }
  };

  const getSite = async () => {
    let sess = session;
    if (!sess) sess = await initSession();
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/${siteId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: sess.id,
      },
    });
    setSite(data.site);
  };

  const initSession = async () => {
    const id = hyperid().uuid;
    await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: siteId,
    });
    const login = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/login`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: siteId,
    });
    setSession(login.data);
    return login.data;
  };

  const getTimeAMPMFormat = (timeStamp, start) => {
    const date = new Date(timeStamp);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    if (start) {
      return hours + ':' + minutes;
    }
    return hours + ':' + minutes + ' ' + ampm;
  };

  if (!siteId) {
    return <div style={{ fontSize: 30 }}>No Site Id provided</div>;
  }

  return (
    <div
      className="w-full h-screen"
      style={{
        backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
        backgroundImage: site?.isBackGroundImage ? `url(${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/getBackgroundImage/${site?.id})` : '',
        backgroundSize: 'cover',
      }}
    >
      <div className="table-responsive" style={{ height: '970px' }}>
        <div>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              borderBottomColor: 'white',
              borderBottomWidth: 1,
            }}
          >
            <span
              style={{
                padding: 15,
                textAlign: 'center',
                borderBottomWidth: 1,
                borderColor: 'solid #000',
                flex: '33.33%',
                color: 'white',
                // backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
                fontSize: 64,
                fontWeight: 700,
              }}
            >
              {site?.eventsColumn[0]}
            </span>
            <span
              style={{
                padding: 15,
                textAlign: 'center',
                borderBottomWidth: 1,
                borderColor: 'solid #000',
                flex: '33.33%',
                color: 'white',
                // backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
                fontSize: 64,
                fontWeight: 700,
              }}
            >
              {site?.eventsColumn[1]}
            </span>
            <span
              style={{
                padding: 15,
                textAlign: 'center',
                borderBottomWidth: 1,
                borderColor: 'solid #000',
                flex: '33.33%',
                color: 'white',
                // backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
                fontSize: 64,
                fontWeight: 700,
              }}
            >
              {site?.eventsColumn[2]}
            </span>
          </div>
          {!slicedEvents ? (
            <div className="activee">
              <span style={{ display: 'flex', flex: '0.33%', padding: 15 }}></span>
              <span style={{ display: 'flex', flex: '0.33%', padding: 15 }} className="text-center">
                Please wait...
              </span>
              <span style={{ display: 'flex', flex: '0.33%', padding: 15 }}></span>
            </div>
          ) : (
            slicedEvents?.map((event) => {
              if (event.status === 'cancelled' || event.timeOut) return null;
              return (
                <div
                  key={`${event.name}event`}
                  style={{ display: 'flex', flexDirection: 'row', borderBottomColor: 'white', borderBottomWidth: 1 }}
                  className={classNames({ activee: event.timeIn >= new Date().getTime() && !event.timeOut })}
                >
                  <span
                    style={{
                      color: 'white',
                      flex: '0.33%',
                      padding: 10,
                      // backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
                      textAlign: 'center',
                      fontWeight: 400,
                    }}
                  >
                    {event.name}
                  </span>
                  <span
                    style={{
                      color: 'white',
                      flex: '0.33%',
                      padding: 10,
                      // backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
                      textAlign: 'center',
                      fontWeight: 400,
                    }}
                  >{`${getTimeAMPMFormat(new Date(event.startDate).getTime(), true)}-${getTimeAMPMFormat(new Date(event.endDate).getTime(), false)}`}</span>
                  <span
                    style={{
                      color: 'white',
                      flex: '0.33%',
                      padding: 10,
                      // backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
                      textAlign: 'center',
                      fontWeight: 400,
                    }}
                  >
                    {event.location}
                  </span>
                </div>
              );
            })
          )}
        </div>
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          backgroundColor: site?.isSolidColor ? `${site?.backgroundColor}` : site?.isBackGroundImage ? `` : 'black',
          display: 'flex',
          flex: 1,
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          borderTopColor: 'white',
          borderTopWidth: 1,
        }}
      >
        <div style={{ width: '50%', paddingLeft: 60 }}>{siteLogoUrl && <img style={{ height: 200 }} src={siteLogoUrl} alt="site logo" />}</div>
        <span style={{ marginTop: 'auto', marginBottom: 'auto', fontSize: 60, color: 'white', paddingRight: 60 }}>{getTimeAMPMFormat(time, false)}</span>
      </div>
    </div>
  );
};
